import { useState } from "react";
import { Zap, Menu, X } from "lucide-react";
import { BRAND } from "../constants/config";

const NAV_LINKS = [
  { href: "#cara-kerja", label: "Cara Kerja", testId: "nav-how-it-works" },
  { href: "#bukti", label: "Bukti", testId: "nav-proof" },
  { href: "#paket", label: "Paket Retensi", testId: "nav-packages" },
  { href: "#order", label: "Order Sekarang", testId: "nav-order" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-40 bg-white/80 backdrop-blur-xl border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-2 group"
        >
          <span className="w-9 h-9 rounded-xl bg-[#E60000] flex items-center justify-center transition-transform group-hover:scale-105">
            <Zap className="w-5 h-5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-heading font-extrabold text-xl tracking-tight text-gray-900">
            Risma<span className="text-[#E60000]">Cell</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="text-sm font-medium text-gray-600 hover:text-[#E60000] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#order"
            data-testid="header-cta-button"
            className="bg-[#E60000] text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-red-700 active:scale-95 transition-[background-color,transform]"
          >
            Hemat Sekarang
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-gray-700"
          onClick={() => setOpen(!open)}
          aria-label="Buka menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-black/5 px-6 py-4 space-y-3"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-sm font-medium text-gray-700 py-2"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#order"
            onClick={() => setOpen(false)}
            className="block text-center bg-[#E60000] text-white text-sm font-semibold px-5 py-3 rounded-full"
          >
            Hemat Sekarang
          </a>
        </div>
      )}
    </header>
  );
};
